import React, { useState, useEffect } from 'react';

// Import CSS & assets
import * as other_helpers from '../../../helpers/Other_helpers';


const ResultItem = ({ item_data, setHighlightedLand, filters }) => {

    const [landLabel, setLandLabel] = useState("");
    useEffect(() => {
        if (item_data?.id) {
            var section = item_data.id.substring(8, 10);
            if (section.substring(0, 1) === "0") { section = section.substring(1) };
            var num = parseInt(item_data.id.substring(10));
            var label = section + "-" + num;
            setLandLabel(label);
        }
        else {
            setLandLabel("");
        }
    }, [item_data]);

    const handleClickItem = () => {
        console.log("CLICKED", item_data);
        setHighlightedLand(item_data);
    }

    return (
        <div className="app__search_result_item_container">
            <div className="app__search_result_item_col00 app__search_result_item_index">
                <span style={{ fontSize: '8px' }}>#</span>{item_data.i + 1}
            </div>
            <div className="app__search_result_item_col0 app__search_result_item_label" onClick={() => { handleClickItem() }}>
                {landLabel}
            </div>
            {(filters && Object.keys(filters).length > 0) &&
                <>
                    {Object.keys(filters).map((filter_key, filter_index) => {
                        var value_txt = "-";
                        if (filters[filter_key]?.format?.key && Object.keys(item_data).includes(filters[filter_key].format.key)) {
                            value_txt = (filters[filter_key]?.format?.pre || "") + (filters[filter_key]?.format?.prettynum >= 0 ? other_helpers.get_pretty_num(item_data[filters[filter_key].format.key].toFixed(filters[filter_key].format.prettynum)) : item_data[filters[filter_key].format.key]) + (filters[filter_key]?.format?.post || "");
                        }
                        return (
                            <div key={'filter_value_' + item_data.i + '_' + filter_index} className="app__search_result_item_col0 app__search_result_item_value">{value_txt}</div>
                        )
                    })}
                </>
            }
        </div>
    );
};

export default ResultItem;